import { Box } from "@schaeffler-commerce/design-system";

/**
 * Route-level code splitting support (task 0065 phase 2 → file-based routes).
 *
 * With file-based routes and autoCodeSplitting, route components load as split
 * chunks; `createStorefrontRouter` registers PagePendingFallback as the
 * router's `defaultPendingComponent`, so it acts as the Suspense fallback
 * while a split component chunk loads — rendered inside the shell frame that
 * __root provides, via the router's pending boundary. There are no per-route
 * `<Suspense>` wrappers anymore, and it never swaps the viewport during a
 * loader await (`defaultPendingMs: Infinity` keeps the committed page visible).
 */

/** Space-reserving pending state while an auto-split route component chunk loads. */
export function PagePendingFallback() {
  return <Box sx={{ minHeight: "50vh" }} aria-busy="true" />;
}
